import { createContext, useCallback, useContext, useState } from 'react';
import { fetchJson, responseArray } from '../utils/apiFetch';

const DiscountedProductsContext = createContext();

export const useDiscountedProductsContext = () => useContext(DiscountedProductsContext);

export const DiscountedProductsProvider = ({ children }) => {
    const [discountProducts, setDiscountProducts] = useState([]);
    const [discountedLoader, setDiscountedLoader ] = useState(false)

     const fetchDiscountedProducts = useCallback(async () => {
        if (discountProducts.length > 0) return;
        setDiscountedLoader(true);
        try {
            const response = await fetchJson('/api/product/discounted');
            const productsWithDiscount = responseArray(response, 'products');
            setDiscountProducts(productsWithDiscount);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setDiscountedLoader(false);
        }
    }, [discountProducts.length]);

    return (
        <DiscountedProductsContext.Provider value={{ discountProducts, setDiscountProducts, discountedLoader, setDiscountedLoader, fetchDiscountedProducts }}>
            {children}
        </DiscountedProductsContext.Provider>
    );
};
